export function initItinerarySlider() {
	const el = document.querySelector(".itinerary-slider");
	if (!el) return;

	const slider = new Splide(el, {
		type: "slide",
		perPage: 3,
		rewind: true,
		speed: 600,
		autoplay: true,
		arrows: true,
		pagination: false,
		breakpoints: {
			768: {
				perPage: 1,
			},
			1024: {
				perPage: 2,
			},
		},
	});
	slider.mount();
}
